import React from 'react';
import img1 from '../data/1 number.jpg';
import img2 from '../data/img2.jpg';
import img3 from "../data/img3.jpg";
import img4 from "../data/img4.jpg"
import img5 from "../data/5 number.jpg"
import { BsLightningCharge } from "react-icons/bs";
import { GiSodaCan } from "react-icons/gi";
import { LuVegan } from "react-icons/lu";
import { GiChemicalDrop } from "react-icons/gi";

const Home = () => {
  return (
    <div className="bg-black w-full ">
      {/* part-1 */}
      <div className='place-items-center'>
           <img src={img1} alt="Home" className="w-full lg:w-[500px] lg:h-[600px]"/>
      </div>
      

      {/* part-2 */}
      <div className="w-full lg:h-[800px] relative flex flex-col">
        <img src={img2} alt="party" className="w-full object-cover" />
        <div className="absolute w-full bg-slate-700 opacity-70 lg:top-40 p-6 lg:p-8">
          <div className="text-white font-barlow text-lg sm:text-xl md:text-2xl lg:text-4xl leading-tight">
            Pump Up the Party, Never Let It Fade! with
          </div>
          <div className="text-red-500 font-autograph text-lg md:text-2xl lg:text-3xl ">
            Grim
          </div>
          <div className="text-white text-sm sm:text-md md:text-lg">
            Party fierce, live limitless! Welcome to the wild side with Grim—fuel your fire and keep the night alive!
          </div>
          <button className="w-[160px] h-[40px] bg-red-700 text-white rounded-bl-3xl rounded-tr-3xl mt-4 md:mt-6">
            Contact Now
          </button>
        </div>
      </div>

      {/* part-3 */}
      <div className="relative flex justify-center items-center">
       <img src={img3} className="w-full h-auto sm:h-screen lg:h-[900px] object-cover"
  alt="part2"
/>
        <div className="absolute lg:top-80 flex flex-wrap justify-center items-center gap-5 md:gap-6 lg:gap-10 w-[90%] sm:w-[80%] md:w-[70%]">
          {[
            { icon: <BsLightningCharge className="text-4xl sm:text-6xl md:text-8xl lg:text-[120px]" />, text: "CAFFEINE" },
            { icon: <GiSodaCan className="text-4xl sm:text-6xl md:text-8xl lg:text-[120px]" />, text: "LOW IN SODIUM" },
            { icon: <LuVegan className="text-4xl sm:text-6xl md:text-8xl lg:text-[120px]" />, text: "VEGAN" },
            { icon: <GiChemicalDrop className="text-4xl sm:text-6xl md:text-8xl lg:text-[120px]" />, text: "B-GROUP VITAMINS" },
          ].map((item, index) => (
            <div key={index} className="w-full sm:w-auto bg-white flex flex-col justify-center items-center border-2 border-red-700 sm:p-6 md:p-8">
              {item.icon}
              <p className="text-xs sm:text-sm md:text-lg">{item.text}</p>
            </div>
          ))}
        </div>
      </div>

      {/* Part - 4 */}
      <div>
        <div></div>
        <div></div>
      </div>

      {/* Part - 5 */}

   <div className="mt-10 relative">
  <img src={img4} alt="img4" className="w-full object-cover" />
  <div className="w-full sm:w-[60%] md:w-[45%] lg:w-[35%] absolute top-10 p-4">
    <p className="font-barlow text-[32px] sm:text-[40px] md:text-[48px] lg:text-[52px] font-bold leading-tight sm:leading-[42px] md:leading-[48px] lg:leading-[52px] text-white">
     Ignite. Recharge. Flourish.
    </p>
    <p className="font-barlow text-[16px] sm:text-[18px] md:text-[20px] leading-[22px] sm:leading-[24px] md:leading-[26px] text-white mt-5">
      Never hit pause! Keep the night alive and your energy unstoppable. Reboot your body, recharge your mind, and party without limits!
    </p>
    <button className="font-barlow text-[18px] sm:text-[20px] md:text-[22px] font-medium leading-[20px] text-black bg-red-700 px-6 py-3 rounded-bl-3xl rounded-tr-3xl mt-4">
      Contact Now
    </button>
  </div>
</div>

      {/* Part - 6 */}
      <div className='lg:flex p-16 gap-4 text-white max-h-[400px]'>
        <div className='space-y-4'>
          <p className='font-semibold'>Sunrise Sessions</p>
          <hr/>
          <p>The night was electric, but the new day calls! Refuel, recharge, and reset—bring back your energy, restore your balance, and seize the day!</p>
        </div>
        <div className='space-y-4'>
          <p className='font-semibold'>Endurance Boost</p>
          <hr/>
          <p>Power through the weekend—own the nights, embrace the mornings, and make every moment count!</p>
        </div>
        <div className='space-y-4'>
          <p className='font-semibold'>Journey Ally</p>
          <hr/>
          <p>Fuel the thrill, defy limits—stay unstoppable no matter where the road takes you!</p>
        </div>
      </div>

      {/* part -7 */}
      <div className='place-items-center'>
        <img src={img5} alt='img5' className='w-full lg:w-[560px] lg:h-[560px]'/>
      </div>
      
    </div>
  );
};

export default Home;